import { inject, Injectable, LOCALE_ID } from "@angular/core";

import { ILgFormatter, ILgFormatterOptions } from "../implementation/formatter-types";
import { MoneyScaledFormatter } from "../implementation/money-scaled-formatter";
import { ILgFormatterFactory } from "./formatter-factory-types";
import { getCurrencyMetadata } from "../../i18n/getCurrencyMetadata";
import { LG_CURRENCY_CODE } from "../../i18n/i18n.types";
import { LG_FORMATTER_OPTIONS } from "./lg-formatter-options";

@Injectable({ providedIn: "root" })
export class MoneyScaledFormatterFactory implements ILgFormatterFactory {
    private _currencyCode = inject(LG_CURRENCY_CODE);
    private _locale = inject(LOCALE_ID);
    private _localFormatterOptions = inject(LG_FORMATTER_OPTIONS, { optional: true });

    names = ["moneyScaled"];

    create(defaultOptions: ILgFormatterOptions = {}): ILgFormatter<number> {
        return new MoneyScaledFormatter(
            { ...defaultOptions, ...this._localFormatterOptions },
            getCurrencyMetadata(this._currencyCode),
            this._locale
        );
    }
}
